module.exports = __webpack_public_path__ + "19805ff0f05a68a5809432dd6801554f.svg";